module.exports = __webpack_public_path__ + "img/arrow-left-1.20c9c096.svg";